import { DocumentDetailsUploadPage } from "../DocumentUpload/Page";

// TODO: Replace with custom TB Test guided upload workflow
// For now, we return the default document upload flow.
export function DocumentDetailsTbTestGuidedUploadPage() {
  return <DocumentDetailsUploadPage />;
}
